@if (!poll) {
  <app-spinner></app-spinner>
}
@if (poll) {
  <div class="poll-editor">
    <div>
      <h1>
        <a routerLink="/polls/{{poll.slug}}">
          {{ poll.title }}
          <tyt-tag>{{ poll.type }}</tyt-tag>
        </a>
        &raquo;
        Post an Update
      </h1>
    </div>
    <p>The update will appear on the petition page just above the petition description. Useful for
      having a visually distinctive update to catch visitors' attention. You can also email this update
      to all users who have signed this petition.
    </p>
    <br>
      <form>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Message</mat-label>
          <textarea matInput cdkTextareaAutosize name="postBody" id="postBody" placeholder="Enter the post body here"
          [(ngModel)]="post.body"></textarea>
        </mat-form-field>
        <br>
          <div>
            <mat-checkbox name="sendEmail" [(ngModel)]="post.send_email">Send email when published</mat-checkbox>
          </div>
          <em class="explanation indented">
            Send this update message as an email to all visitors who have already signed the petition.
            If the update is already published, setting this checkbox to true will cause the update email to be sent
            immediately.
            If an email was already sent for this update, changing this setting has no effect (it will not send multiple
            emails).
          </em>
          <div>
            <mat-checkbox name="hidden" [(ngModel)]="post.hidden">Hide this update</mat-checkbox>
          </div>
          <em class="explanation indented">
            The update will be hidden from the petition page. Useful if the update needs to be rescinded after posting, or to
            reduce the amount of updates shown on the petition page without explicitly deleting this post.
          </em>
          <br />
          <br />
          @if (post.status !== 'published') {
            @if (!post.id) {
              <button mat-button (click)="save()">Save Draft</button>
            }
            @if (post.id) {
              <button mat-button (click)="save()">Save Draft</button>
              <button mat-button (click)="publish()">Publish</button>
            }
          }
          @if (post.status === 'published') {
            <button mat-button (click)="save()">Publish Changes</button>
            &nbsp;
            @if (post.published_at || publishSuccess) {
              <tyt-tag>Published</tyt-tag>
            }
          }
        </form>
      </div>
    }